<template>
  <div class="TemperatureAutomationWidget lxn-w100 lxn-h100 lxn-pos-rel" :class="disabledClass">
    <div class="TemperatureAutomationWidget-wrapper-top lxn-w100">
      <div class="TemperatureAutomationWidget-wrapper-left lxn-h100 lxn-float-left">
        <div class="TemperatureAutomationWidget-wrapper-isActive">
          <div @click="changeIsActive(false);" v-if="widget.settings.isActive" class="lxn-display-table lxn-margin-auto lxn-cursor-pointer">
            <ButtonIcon :size="36" bgColor="#ECECEC" icon="turnOff" iconColor="#1ea5de" :padding="4" :borderWidth="2" borderColor="#54C3ED" :isRound="true" />
          </div>
          <div @click="changeIsActive(true);" v-else class="lxn-display-table lxn-margin-auto lxn-cursor-pointer">
            <ButtonIcon :size="36" bgColor="#ECECEC" icon="turnOff" iconColor="#f36c4f" :padding="4" :borderWidth="2" borderColor="#F6AF94" :isRound="true" />
          </div>
          <div @click="refresh();" class="TemperatureAutomationWidget-wrapper-refresh">
            <ButtonIcon :size="20" bgColor="#ECECEC" icon="refresh" iconColor="#1ea5de" :padding="3" :borderWidth="1" borderColor="#54C3ED" :isRound="true"  />
          </div>
        </div>
      </div>
      <div class="TemperatureAutomationWidget-wrapper-center lxn-h100 lxn-float-left lxn-text-center lxn-text-7seg lxn-pos-rel" :class="deactivatedClass">
        {{widget.settings.setPoint/stepSize}}
      </div>
      <div class="TemperatureAutomationWidget-wrapper-right lxn-h100 lxn-float-right">
        <div class="TemperatureAutomationWidget-wrapper-season" :class="deactivatedClass">
          <div v-if="widget.settings.automationType == 3" class="lxn-display-table lxn-margin-auto lxn-cursor-pointer">
            <ButtonIcon :size="30" bgColor="#ECECEC" icon="humidity" iconColor="#1ea5de" :padding="0" />
          </div>
          <div @click="changeSeason('winter');" v-else-if="widget.settings.season == 'summer'" class="lxn-display-table lxn-margin-auto lxn-cursor-pointer">
            <ButtonIcon :size="30" bgColor="#ECECEC" icon="cool" iconColor="#1ea5de" :padding="0" />
          </div>
          <div @click="changeSeason('summer');" v-else class="lxn-display-table lxn-margin-auto lxn-cursor-pointer">
            <ButtonIcon :size="30" bgColor="#ECECEC" icon="heat" iconColor="#efad1f" :padding="0" />
          </div>
        </div>
      </div>
    </div>
    <div class="TemperatureAutomationWidget-wrapper-svg lxn-pos-abs" :class="deactivatedClass">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.7 33" class="lxn-w100 lxn-h100"><linearGradient :id="svgStyle.id1" gradientUnits="userSpaceOnUse" x1="47.722" y1="19.491" x2="18.871" y2="16.683"><stop offset="0" :stop-color="svgStyle.stop1"/><stop offset="1" :stop-color="svgStyle.stop2"/></linearGradient><path d="M75.4 33H.3c3.6-16.7 18-29.1 35.1-30.2h0L37.8.4l2.4 2.4C57.4 3.9 71.8 16.3 75.4 33z" :fill="svgStyle.id1Ref"/><linearGradient :id="svgStyle.id2" gradientUnits="userSpaceOnUse" x1="0" y1="16.5" x2="75.7" y2="16.5"><stop offset="0" :stop-color="svgStyle.borderStop1"/><stop offset="1" :stop-color="svgStyle.borderStop2"/></linearGradient><path d="M75.7 33h-.3c-3.6-16.7-18-29.1-35.1-30.2h0L37.9.4l-2.4 2.4C18.3 3.9 3.9 16.3.3 33H0C3.6 16.2 18.2 3.6 35.4 2.5L37.9 0l2.5 2.5C57.6 3.6 72.1 16.1 75.7 33z" :fill="svgStyle.id2Ref"/><path d="M38 28.2V16.7h-.4v11.5c-.6.1-1 .6-1 1.2 0 .7.5 1.2 1.2 1.2S39 30 39 29.4c.1-.6-.4-1.2-1-1.2zm-.1 2.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9z" fill="#f2f3f3"/><path d="M37.7 4.3h.4v5.4h-.4zm21.86 14.26l3.818-3.818.283.283-3.818 3.818zM16.2 18.4l-.2.3-3.9-3.8.3-.3zm27.446-8.2L44.7 4.915l.392.078-1.055 5.296zM68.1 20.5l-4.5 3-.2-.3 4.5-3zm-47.2-5.9l-.3.2-3-4.5.3-.2zm31-7.5l-2.1 5-.3-.1 2.1-5zm19.5 19.7l-5 2.1-.1-.3 5-2.1zM26.2 12l-.3.1-2.1-5 .4-.1zm4.374-7l.392-.078 1.058 5.295-.392.078zm24.246 9.726l2.998-4.492.333.222-2.998 4.492zM12.3 23.1l-.2.3-4.5-3 .2-.3zm-2.8 5.3l-.2.3-5-2 .2-.4z" fill="#fff"/><g fill="#f2f3f3"><circle @click="changeSetPoint(stepSize);" class="lxn-cursor-pointer" cx="49.8" cy="23.6" r="7"/><circle @click="changeSetPoint(-stepSize);" class="lxn-cursor-pointer" cx="26" cy="23.6" r="7"/></g><path d="M22.9 23.6h0a.65.65 0 0 1 .6-.6h4.9a.65.65 0 0 1 .6.6h0a.65.65 0 0 1-.6.6h-4.9a.65.65 0 0 1-.6-.6z" :fill="svgStyle.minusColor" class="lxn-cursor-pointer" @click="changeSetPoint(-stepSize);" /><path d="M52.8 23.6a.65.65 0 0 1-.6.6h-1.9v1.9a.65.65 0 0 1-.6.6.65.65 0 0 1-.6-.6v-1.9h-1.9a.65.65 0 0 1-.6-.6.65.65 0 0 1 .6-.6h1.9v-1.9a.65.65 0 0 1 .6-.6.65.65 0 0 1 .6.6V23h1.9c.3.1.6.3.6.6z" :fill="svgStyle.plusColor" class="lxn-cursor-pointer"  @click="changeSetPoint(stepSize);"/></svg>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'
import { HUMIDITY_AUTOMATION_OFFSET, TEMPERATURE_AUTOMATION_OFFSET } from '../../statics/configs'

export default {
  name: 'TemperatureAutomationWidget',
  props: {
    index: Number
  },
  components: {
    ButtonIcon
  },
  data: function () {
    return {
      switchLocked: false,
      isButtonActive: false,
    }
  },
  mounted: function () {
  },
  computed: {
    widget: function () {
      if(this.index == -1){
        return {
          settings: {
            isActive: true,
            setPoint: 270,
            season: 'winter',
          }
        };
      }
      return this.$store.state.widgets[this.index];
    },
    stepSize: function () {
      return this.widget.settings.automationType == 3 ? 1 : 10;
    },
    offset: function () {
      return this.widget.settings.automationType == 3 ? HUMIDITY_AUTOMATION_OFFSET : TEMPERATURE_AUTOMATION_OFFSET;
    },
    widgetColor: function () {
      if(this.index == -1){
        return '';
      }
      return this.$store.state.themeMainColors[this.widget.color];
    },
    hub: function () {
      if(this.index == -1){
        return null;
      }
      return this.$store.getters.getHubByUUID(this.widget.hubUUID);
    },
    isHubOffline: function () {
      if(this.index == -1){
        return false;
      }
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    disabledClass: function () {
      if(this.index == -1){
        return "";
      }
      if(this.isHubOffline){
        return "disabled";
      }else{
        return "";
      }
    },
    deactivatedClass: function () {
      if(this.index == -1){
        return "";
      }
      if(!this.widget.settings.isActive){
        return 'deactive';
      }else{
        return '';
      }
    },
    svgStyle: function () {
      if(this.widget.settings.season != 'winter'){
        return {
          id1: 'A' + this.index,
          id1Ref: 'url(#A' + this.index + ')',
          id2: 'B' + this.index,
          id2Ref: 'url(#B' + this.index + ')',
          stop1: '#358FC1',
          stop2: '#8FC9EE',
          borderStop1: '#7AA2CE',
          borderStop2: '#5486C5',
          minusColor: '#7CBAE3',
          plusColor: '#5486C5',
        }
      }else{
        return {
          id1: 'A' + this.index,
          id1Ref: 'url(#A' + this.index + ')',
          id2: 'B' + this.index,
          id2Ref: 'url(#B' + this.index + ')',
          stop1: '#ee7c22',
          stop2: '#efc154',
          borderStop1: '#cea648',
          borderStop2: '#cd6c1c',
          minusColor: '#f0c153',
          plusColor: '#ef7d22',
        }
      }
    }
  },
  methods: {
    changeSetPoint: function (diff) {
      if(this.index == -1){
        return;
      }
      if(this.isHubOffline) {
        return;
      }
      if(!this.widget.settings.isActive){
        return;
      }
      var newSetpoint = this.widget.settings.setPoint + diff;

      if(newSetpoint < 0 || newSetpoint > 500){
        return;
      }

      this.$store.commit('setAppBusy', true);

      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: false,
      });

      var watchList = [];

      //eventId for cool on
      var coolOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3);
      //dummy eventId for cool on
      var coolOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 4;

      //eventId for cool off
      var coolOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 1;
      //dummy eventId for cool off
      var coolOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 5;

      //eventId for heat on
      var heatOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 2;
      //dummy eventId for heat on
      var heatOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 6;

      //eventId for heat off
      var heatOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 3;
      //dummy eventId for heat off
      var heatOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 7;

      if(this.widget.settings.season == 'summer'){
        watchList.push({
          deviceUUID: this.widget.settings.sensorUUID,
          parameterId: this.widget.settings.sensorParameterId,
          valueOfChange: newSetpoint + this.offset,
          relation: CONFIGS.RELATION_GREATER_THAN_EQUAL,
          eventId: coolOnActualEventId,
        });
        watchList.push({
          deviceUUID: this.widget.settings.sensorUUID,
          parameterId: this.widget.settings.sensorParameterId,
          valueOfChange: newSetpoint - this.offset,
          relation: CONFIGS.RELATION_LESS_THAN_EQUAL,
          eventId: coolOffActualEventId,
        });
      }else if(this.widget.settings.season == 'winter'){
        watchList.push({
          deviceUUID: this.widget.settings.sensorUUID,
          parameterId: this.widget.settings.sensorParameterId,
          valueOfChange: newSetpoint - this.offset,
          relation: CONFIGS.RELATION_LESS_THAN_EQUAL,
          eventId: heatOnActualEventId,
        });
        watchList.push({
          deviceUUID: this.widget.settings.sensorUUID,
          parameterId: this.widget.settings.sensorParameterId,
          valueOfChange: newSetpoint + this.offset,
          relation: CONFIGS.RELATION_GREATER_THAN_EQUAL,
          eventId: heatOffActualEventId,
        });
      }

      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });

      this.$store.dispatch('modifyParameterWatches', {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
        bodyContent: {
          watchList: watchList,
        }
      })
      .then( () => {
        this.$store.dispatch('readNodeInstructions', {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          nodeUUID: this.widget.settings.sensorUUID
        })
        .then( response => {
          var sensorInstructionList = response.body.bodyContent.instructionList;
          var newSensorInstructionList = [];
          var season = this.widget.settings.season;
          for(var i = 0; i < sensorInstructionList.length; i++){
            if(sensorInstructionList[i].internalAction.valueOfChange != coolOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != coolOffDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != heatOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != heatOffDummyEventId){
              newSensorInstructionList.push(sensorInstructionList[i]);
            }
          }
          if(season == 'summer'){
            newSensorInstructionList.push({
              eventToWatch: {
                parameterId: this.widget.settings.sensorParameterId,
                valueToReach: newSetpoint + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                direction: CONFIGS.EVENT_DIRECTION_RISING,
              },
              internalAction: {
                parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                valueOfChange: coolOnDummyEventId,
                typeOfAction: CONFIGS.ACTION_TYPE_SET,
              },
              timeDelay: 0,
            })
            newSensorInstructionList.push({
              eventToWatch: {
                parameterId: this.widget.settings.sensorParameterId,
                valueToReach: newSetpoint - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                direction: CONFIGS.EVENT_DIRECTION_FALLING,
              },
              internalAction: {
                parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                valueOfChange: coolOffDummyEventId,
                typeOfAction: CONFIGS.ACTION_TYPE_SET,
              },
              timeDelay: 0,
            })
          }else if(season == 'winter'){
            newSensorInstructionList.push({
              eventToWatch: {
                parameterId: this.widget.settings.sensorParameterId,
                valueToReach: newSetpoint - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                direction: CONFIGS.EVENT_DIRECTION_FALLING,
              },
              internalAction: {
                parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                valueOfChange: heatOnDummyEventId,
                typeOfAction: CONFIGS.ACTION_TYPE_SET,
              },
              timeDelay: 0,
            })
            newSensorInstructionList.push({
              eventToWatch: {
                parameterId: this.widget.settings.sensorParameterId,
                valueToReach: newSetpoint + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                direction: CONFIGS.EVENT_DIRECTION_RISING,
              },
              internalAction: {
                parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                valueOfChange: heatOffDummyEventId,
                typeOfAction: CONFIGS.ACTION_TYPE_SET,
              },
              timeDelay: 0,
            })
          }
          this.$store.dispatch('setInstructionsOnDevice', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.widget.settings.sensorUUID,
            instructions: newSensorInstructionList,
          })
          .then( () => {
            //It was successfull!!! Do nothing.
          })
          .catch( () => {
            alert(this.$store.getters.language.texts.TemperatureAutomationWidget_alertSensorFailed);
          })
          .finally( () => {
            this.$store.commit('setHubStatus', {
              hubIndex: this.hub.index,
              stateUpdateEnabled: true,
            });
            this.$store.commit('setAppBusy', false);
          })
        })
        .catch( () => {
          alert(this.$store.getters.language.texts.TemperatureAutomationWidget_alertSensorFailed);
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
          this.$store.commit('setAppBusy', false);
        });
        var newWidget = this.widget;
        newWidget.settings.setPoint = newSetpoint;
        this.$store.commit('editWidget', {
          widgetIndex: this.index,
          widget: newWidget,
        });
        this.$store.commit('saveState');
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHubFailed);
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: true,
        });
        this.$store.commit('setAppBusy', false);
      })
    },
    changeIsActive: function (newIsActive) {
      if(this.index == -1){
        return;
      }
      this.$store.commit('setAppBusy', true);

      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: false,
      });

      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });

      var maskList = [];

      //eventId for cool on
      var coolOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3);
      //dummy eventId for cool on
      var coolOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 4;

      //eventId for cool off
      var coolOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 1;
      //dummy eventId for cool off
      var coolOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 5;

      //eventId for heat on
      var heatOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 2;
      //dummy eventId for heat on
      var heatOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 6;

      //eventId for heat off
      var heatOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 3;
      //dummy eventId for heat off
      var heatOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 7;

      if(newIsActive) {
        maskList.push({
          eventId: coolOnActualEventId,
          isMasked: false,
        });
        maskList.push({
          eventId: coolOffActualEventId,
          isMasked: false,
        });
        maskList.push({
          eventId: heatOnActualEventId,
          isMasked: false,
        });
        maskList.push({
          eventId: heatOffActualEventId,
          isMasked: false,
        });
      }else{
        maskList.push({
          eventId: coolOnActualEventId,
          isMasked: true,
        });
        maskList.push({
          eventId: coolOffActualEventId,
          isMasked: true,
        });
        maskList.push({
          eventId: heatOnActualEventId,
          isMasked: true,
        });
        maskList.push({
          eventId: heatOffActualEventId,
          isMasked: true,
        });
      }
      this.$store.dispatch('setEventMasks', {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
        bodyContent: {
          maskList: maskList
        }
      })
      .then( () => {
        this.$store.dispatch('readNodeInstructions', {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          nodeUUID: this.widget.settings.sensorUUID
        })
        .then( response => {
          var sensorInstructionList = response.body.bodyContent.instructionList;
          var newSensorInstructionList = [];
          for(var i = 0; i < sensorInstructionList.length; i++){
            if(sensorInstructionList[i].internalAction.valueOfChange != coolOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != coolOffDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != heatOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != heatOffDummyEventId){
              newSensorInstructionList.push(sensorInstructionList[i]);
            }
          }
          if(newIsActive){
            if(this.widget.settings.season == 'summer'){
              newSensorInstructionList.push({
                eventToWatch: {
                  parameterId: this.widget.settings.sensorParameterId,
                  valueToReach: this.widget.settings.setPoint + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                  direction: CONFIGS.EVENT_DIRECTION_RISING,
                },
                internalAction: {
                  parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                  valueOfChange: coolOnDummyEventId,
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                },
                timeDelay: 0,
              })
              newSensorInstructionList.push({
                eventToWatch: {
                  parameterId: this.widget.settings.sensorParameterId,
                  valueToReach: this.widget.settings.setPoint - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                  direction: CONFIGS.EVENT_DIRECTION_FALLING,
                },
                internalAction: {
                  parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                  valueOfChange: coolOffDummyEventId,
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                },
                timeDelay: 0,
              })
            }else if(this.widget.settings.season == 'winter'){
              newSensorInstructionList.push({
                eventToWatch: {
                  parameterId: this.widget.settings.sensorParameterId,
                  valueToReach: this.widget.settings.setPoint - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                  direction: CONFIGS.EVENT_DIRECTION_FALLING,
                },
                internalAction: {
                  parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                  valueOfChange: heatOnDummyEventId,
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                },
                timeDelay: 0,
              })
              newSensorInstructionList.push({
                eventToWatch: {
                  parameterId: this.widget.settings.sensorParameterId,
                  valueToReach: this.widget.settings.setPoint + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                  direction: CONFIGS.EVENT_DIRECTION_RISING,
                },
                internalAction: {
                  parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                  valueOfChange: heatOffDummyEventId,
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                },
                timeDelay: 0,
              })
            }
          }
          this.$store.dispatch('setInstructionsOnDevice', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.widget.settings.sensorUUID,
            instructions: newSensorInstructionList,
          })
          .then( () => {
            //It was successfull!!! Do nothing.
          })
          .catch( () => {
            alert(this.$store.getters.language.texts.TemperatureAutomationWidget_alertSensorFailed);
          })
          .finally( () => {
            this.$store.commit('setHubStatus', {
              hubIndex: this.hub.index,
              stateUpdateEnabled: true,
            });
            this.$store.commit('setAppBusy', false);
          })
        })
        .catch( () => {
          alert(this.$store.getters.language.texts.TemperatureAutomationWidget_alertSensorFailed);
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
          this.$store.commit('setAppBusy', false);
        });
        var newWidget = this.widget;
        newWidget.settings.isActive = newIsActive;
        this.$store.commit('editWidget', {
          widgetIndex: this.index,
          widget: newWidget,
        });
        this.$store.commit('saveState');
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHubFailed);
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: true,
        });
        this.$store.commit('setAppBusy', false);
      })
    },
    changeSeason: function (newSeason) {
      if(this.index == -1){
        return;
      }
      if (this.widget.settings.heatOnCommand.length == 0 || this.widget.settings.heatOffCommand.length == 0 || this.widget.settings.coolOnCommand.length == 0 || this.widget.settings.coolOffCommand.length == 0){
        return;
      }
      if(!this.widget.settings.isActive){
        return;
      }

      this.$store.commit('setAppBusy', true);

      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: false,
      });

      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });

      //eventId for cool on
      var coolOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3);
      //dummy eventId for cool on
      var coolOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 4;

      //eventId for cool off
      var coolOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 1;
      //dummy eventId for cool off
      var coolOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 5;

      //eventId for heat on
      var heatOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 2;
      //dummy eventId for heat on
      var heatOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 6;

      //eventId for heat off
      var heatOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 3;
      //dummy eventId for heat off
      var heatOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (this.widget.settings.groupId & 0xFF) << 3) + 7;

      this.$store.dispatch('readHubWatches', {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
      })
      .then( (response) => {
        var watchList = response.body.bodyContent.watchList;
        var newWatchList = [];
        for(var i = 0; i < watchList.length; i++){
          if(newSeason == 'winter'){
            if(watchList[i].eventId != coolOnActualEventId && watchList[i].eventId != coolOffActualEventId){
              newWatchList.push(watchList[i]);
            }
          }else{
            if(watchList[i].eventId != heatOnActualEventId && watchList[i].eventId != heatOffActualEventId){
              newWatchList.push(watchList[i]);
            }
          }
        }
        if (this.widget.settings.automationType == 3){
          if(newSeason == 'summer'){
            newWatchList.push({
              deviceUUID: this.widget.settings.sensorUUID,
              parameterId: this.widget.settings.sensorParameterId,
              valueOfChange: CONFIGS.HUMIDITY_AUTOMATION_SETPOINT + CONFIGS.HUMIDITY_AUTOMATION_OFFSET,
              relation: CONFIGS.RELATION_GREATER_THAN_EQUAL,
              eventId: coolOnActualEventId,
            });
            newWatchList.push({
              deviceUUID: this.widget.settings.sensorUUID,
              parameterId: this.widget.settings.sensorParameterId,
              valueOfChange: CONFIGS.HUMIDITY_AUTOMATION_SETPOINT - CONFIGS.HUMIDITY_AUTOMATION_OFFSET,
              relation: CONFIGS.RELATION_LESS_THAN_EQUAL,
              eventId: coolOffActualEventId,
            });
          }
        }
        else if(newSeason == 'summer'){
          newWatchList.push({
            deviceUUID: this.widget.settings.sensorUUID,
            parameterId: this.widget.settings.sensorParameterId,
            valueOfChange: CONFIGS.TEMPERATURE_AUTOMATION_COOL_SETPOINT + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
            relation: CONFIGS.RELATION_GREATER_THAN_EQUAL,
            eventId: coolOnActualEventId,
          });
          newWatchList.push({
            deviceUUID: this.widget.settings.sensorUUID,
            parameterId: this.widget.settings.sensorParameterId,
            valueOfChange: CONFIGS.TEMPERATURE_AUTOMATION_COOL_SETPOINT - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
            relation: CONFIGS.RELATION_LESS_THAN_EQUAL,
            eventId: coolOffActualEventId,
          });
        }else if(newSeason == 'winter'){
          newWatchList.push({
            deviceUUID: this.widget.settings.sensorUUID,
            parameterId: this.widget.settings.sensorParameterId,
            valueOfChange: CONFIGS.TEMPERATURE_AUTOMATION_HEAT_SETPOINT - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
            relation: CONFIGS.RELATION_LESS_THAN_EQUAL,
            eventId: heatOnActualEventId,
          });
          newWatchList.push({
            deviceUUID: this.widget.settings.sensorUUID,
            parameterId: this.widget.settings.sensorParameterId,
            valueOfChange: CONFIGS.TEMPERATURE_AUTOMATION_HEAT_SETPOINT + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
            relation: CONFIGS.RELATION_GREATER_THAN_EQUAL,
            eventId: heatOffActualEventId,
          });
        }
        this.$store.dispatch('setWatchOnHub', {
          messagingHook: messagingHook,
          hubUUID: this.hub.uuid,
          bodyContent: {
            watchList: newWatchList,
          }
        })
        .then( () => {
          this.$store.dispatch('readNodeInstructions', {
            messagingHook: messagingHook,
            hubUUID: this.hub.uuid,
            nodeUUID: this.widget.settings.sensorUUID
          })
          .then( response => {
            var sensorInstructionList = response.body.bodyContent.instructionList;
            var newSensorInstructionList = [];
            for(var i = 0; i < sensorInstructionList.length; i++){
              if(sensorInstructionList[i].internalAction.valueOfChange != coolOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != coolOffDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != heatOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != heatOffDummyEventId){
                newSensorInstructionList.push(sensorInstructionList[i]);
              }
            }
            if(newSeason == 'summer'){
              newSensorInstructionList.push({
                eventToWatch: {
                  parameterId: this.widget.settings.sensorParameterId,
                  valueToReach: CONFIGS.TEMPERATURE_AUTOMATION_COOL_SETPOINT + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                  direction: CONFIGS.EVENT_DIRECTION_RISING,
                },
                internalAction: {
                  parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                  valueOfChange: coolOnDummyEventId,
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                },
                timeDelay: 0,
              })
              newSensorInstructionList.push({
                eventToWatch: {
                  parameterId: this.widget.settings.sensorParameterId,
                  valueToReach: CONFIGS.TEMPERATURE_AUTOMATION_COOL_SETPOINT - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                  direction: CONFIGS.EVENT_DIRECTION_FALLING,
                },
                internalAction: {
                  parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                  valueOfChange: coolOffDummyEventId,
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                },
                timeDelay: 0,
              })
            }else if(newSeason == 'winter'){
              newSensorInstructionList.push({
                eventToWatch: {
                  parameterId: this.widget.settings.sensorParameterId,
                  valueToReach: CONFIGS.TEMPERATURE_AUTOMATION_HEAT_SETPOINT - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                  direction: CONFIGS.EVENT_DIRECTION_FALLING,
                },
                internalAction: {
                  parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                  valueOfChange: heatOnDummyEventId,
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                },
                timeDelay: 0,
              })
              newSensorInstructionList.push({
                eventToWatch: {
                  parameterId: this.widget.settings.sensorParameterId,
                  valueToReach: CONFIGS.TEMPERATURE_AUTOMATION_HEAT_SETPOINT + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                  direction: CONFIGS.EVENT_DIRECTION_RISING,
                },
                internalAction: {
                  parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                  valueOfChange: heatOffDummyEventId,
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                },
                timeDelay: 0,
              })
            }
            this.$store.dispatch('setInstructionsOnDevice', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.widget.settings.sensorUUID,
              instructions: newSensorInstructionList,
            })
            .then( () => {
              //It was successfull!!! Do nothing.
            })
            .catch( () => {
              alert(this.$store.getters.language.texts.TemperatureAutomationWidget_alertSensorFailed);
            })
            .finally( () => {
              this.$store.commit('setHubStatus', {
                hubIndex: this.hub.index,
                stateUpdateEnabled: true,
              });
              this.$store.commit('setAppBusy', false);
            })
          })
          .catch( () => {
            alert(this.$store.getters.language.texts.TemperatureAutomationWidget_alertSensorFailed);
            this.$store.commit('setHubStatus', {
              hubIndex: this.hub.index,
              stateUpdateEnabled: true,
            });
            this.$store.commit('setAppBusy', false);
          });
          var newWidget = this.widget;
          newWidget.settings.season = newSeason;
          newWidget.settings.setPoint = (newSeason == 'summer') ? CONFIGS.TEMPERATURE_AUTOMATION_COOL_SETPOINT : CONFIGS.TEMPERATURE_AUTOMATION_HEAT_SETPOINT,
          this.$store.commit('editWidget', {
            widgetIndex: this.index,
            widget: newWidget,
          });
          this.$store.commit('saveState');
        })
        .catch( response => {
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
          alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHubFailed);
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
          this.$store.commit('setAppBusy', false);
        })
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHubFailed);
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: true,
        });
        this.$store.commit('setAppBusy', false);
      })

    },
    refresh: function () {
      if(this.index == -1){
        return;
      }
      this.$store.commit('setAppBusy', true);
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: false,
      });
      this.$store.dispatch('updateAutomations', this.hub.index)
      .then( () => {
        this.$store.commit('setAppBusy', false);
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: true,
        });
      })
      .catch( () => {
        this.$store.commit('setAppBusy', false);
        this.$store.commit('setHubStatus', {
          hubIndex: this.hub.index,
          stateUpdateEnabled: true,
        });
      });
    },
  },
}
</script>

<style>
@media all {
  .TemperatureAutomationWidget {
    padding: 0;
  }
  .TemperatureAutomationWidget.disabled {
    opacity: 0.5;
  }
  .TemperatureAutomationWidget-wrapper-svg {
    left: calc(50% - 115px);
    bottom: 0;
    width: 230px;
    height: 100px;
  }
  .deactive {
    opacity: 0.4;
  }
  .TemperatureAutomationWidget-wrapper-top {
    height: 80px;
  }
  .TemperatureAutomationWidget-wrapper-left {
    width: 40px;
  }
  .TemperatureAutomationWidget-wrapper-center {
    width: calc(100% - 40px - 34px);
    line-height: 80px;
    font-size: 40px;
    color: #53636C;
  }
  .TemperatureAutomationWidget-wrapper-right {
    width: 34px;
  }
  .TemperatureAutomationWidget-wrapper-season {
    height: 80px;
    padding-top: 5px;
  }
  .TemperatureAutomationWidget-wrapper-isActive {
    height: 80px;
    padding-top: 5px;
  }
  .TemperatureAutomationWidget-wrapper-refresh {
    margin-left: 10px;
    margin-top: 24px;
  }
}
@media screen and (max-width: 500px) {
  .TemperatureAutomationWidget-wrapper-center {
    font-size: 8vw;
  }
}
</style>
